import React from 'react';
import InsurancePlanList from '../components/InsurancePlanList';

const InsurancePlanListPage: React.FC = () => <InsurancePlanList />;

export default InsurancePlanListPage;
